import API from './api'

const isBrowser = typeof window !== `undefined`
const getHostUser = () => (localStorage.getItem(`token`) ? true : false)

const isAuthRejection = error => {
  const status = error && error.response && error.response.status
  return status === 401 || status === 403
}

export const isHostLoggedIn = () => {
  if (!isBrowser) return false
  // verify their token
  const token = localStorage.getItem(`token`)
  if (token) {
    return API.post(`/token_verify/`, {
      token: localStorage.getItem(`token`),
    })
      .then(res => true)
      .catch(function(error) {
        console.log(error)
        // Only clear the token on real auth rejections. Network blips / 5xx must not
        // force a host logout mid-hunt (e.g. print page or route remount verify).
        if (isAuthRejection(error)) {
          localStorage.removeItem(`token`)
          return false
        }
        // Keep the existing session and treat as still logged in until an
        // authenticated API call proves otherwise.
        return true
      })
  } else {
    return new Promise(function(resolve, reject) {
      resolve(false)
    })
  }
}

export const hostLogout = callback => {
  if (!isBrowser) return
  localStorage.removeItem(`token`)
  callback()
}
